import SearchResultItem from './SearchResultItem'

export default SearchResultItem
